<template>
    <div class="w-full relative flex flex-col items-center">
        <divider class="divider w-screen" color="info"></divider>
        <row class="items-center" justify="space-between" style="max-width: 1920px;">
            <column class="flex xs:items-center" md="1/3" xs="full">
                <img class="my-8"
                     src="@/assets/logos/fitt_dark_clear_cropped.png"
                     style="max-height: 100px;"
                >
            </column>

            <column class="flex items-center" md="1/3" xs="full">
                <a href="https://www.iafcertsearch.org/certified-entity/XOZTQ34RamYO37njAEWpNrC4" target="_blank"><img class="my-8"
                     src="@/assets/isomark.png"
                     style="max-height: 100px;"
                ></a>
            </column>

            <column class="xs:items-center md:items-end px-4" md="1/3" xs="full">
                <btn @click="getFitt()"
                     class="xs:mb-10 md:mb-0 tracking-tight leading-tight"
                     color="primary"
                     dark
                     filled
                     no-padding
                     width="150"
                >
                    <div class="w-full flex justify-center items-center" style="height: 50px;">
                        Get Fitt
                    </div>
                    <!--                    <div class="w-full text-center">-->
                    <!--                        <a href="mailto:fitt@psychai.co" class="flex items-center justify-center" style="width: 150px; height: 50px;">Get fitt</a>-->
                    <!--                    </div>-->
                </btn>
            </column>
        </row>
        <divider class="divider w-screen" color="info"></divider>
        <row class="text-left mt-12" justify="center" style="max-width: 1920px;">
            <column class="poppins-medium tracking-normal leading-tight xs:px-3 sm:px-4 md:px-4 mb-10"
                    md="1/4"
                    sm="1/2"
                    xs="full">
                <div class="uppercase text-secondary mb-4"
                >A product of Psychai Talent Group
                </div>
                <div class="text-secondary">
                    <a href="mailto:hello@fitt.ai">hello@fitt.ai</a>
                    <br>
                    <a href="https://fitt.ai" target="_blank">fitt.ai</a>
                    <br>
                    +1 206 489 0784
                    <br>
                    <br>
                    <b>Dubai:</b><br>
                    PTG Talent Solutions DMCC, OneJLT-05-100, One JLT, Unit 181, Jumeirah Lakes Towers, Dubai, UAE
                    <hr class="mt-3 mb-3">

                    <b>Saudi Arabia:</b><br>
                    3141 Anas Ibn Malik, 8292 Al Malqa Dist. 13521, Riyadh, KSA
                    <hr class="mt-3 mb-3">

                    <b>South Africa:</b><br>
                    2nd Floor, 11 Alice Lane,
                    Alice Lane Building, Sandton, South Africa
                </div>
            </column>
            <column class="poppins-medium tracking-normal leading-tight xs:px-3 sm:px-4 md:px-4 mb-10"
                    md="1/4"
                    sm="1/2"
                    xs="full">
                <div class="uppercase text-secondary mb-4 xs:mt-4 md:mt-0">Legal</div>
                <div class="text-secondary">
                    <router-link active-class="text-primary" to="/privacy">Privacy policy</router-link>
                    <br>
                    <router-link active-class="text-primary" to="/cookie-policy">Cookie policy</router-link>
                    <br>
                    <router-link active-class="text-primary" to="/data-processor-agreement">Data processor agreement
                    </router-link>
                    <br>
                </div>
            </column>
            <column class="poppins-medium tracking-normal leading-tight xs:px-3 sm:px-4 md:px-4 mb-10"
                    md="1/4"
                    sm="1/2"
                    xs="full">
                <div class="uppercase text-secondary mb-4 xs:mt-4 md:mt-0"
                >Privacy Centre
                </div>
                <a href="https://manage.fitt.ai/privacyportal/landing" target="_blank">Visit Privacy Centre</a>
            </column>
            <column class="poppins-medium tracking-normal leading-tight xs:px-3 sm:px-4 md:px-4 mb-10"
                    md="1/4"
                    sm="1/2"
                    xs="full">
                <div class="uppercase text-secondary mb-4 xs:mt-4 md:mt-0"
                >Technical requirements
                </div>
                <div class="flex">
                    <img style="width:20px" src="https://ohdear.app/badges/status-page/01hvneaq2ctnkjzc3vp7bx8n9z/small" alt="status page badge" />
                    <a href="https://ohdear.app/status-page/fitt" class="ml-2" target="_blank">System Status</a>
                </div>
                <div class="mt-4">
                    The web application is available on:
                </div>
                <row>
                    <a href="https://www.google.com/chrome/" target="_blank">
                        <icon icon="google-chrome"></icon>
                    </a>
                    <a href="https://www.mozilla.org/en-US/firefox/new/" target="_blank" class="mx-3">
                        <icon icon="firefox"></icon>
                    </a>
                    <a href="https://www.microsoft.com/en-us/edge" target="_blank">
                        <icon icon="microsoft-edge"></icon>
                    </a>
                </row>
                <div class="mt-3">
                    Alternatively, a fitt desktop application is available for Windows and MacOS.
                </div>
                <router-link class="text-primary mt-3" to="/technical-requirements">Read More...</router-link>
            </column>
            <!--            <column xs="full" md="1/5">-->
            <!--                <div class="uppercase text-secondary mb-4 xs:mt-4 md:mt-0 poppins-medium tracking-normal leading-tight">Get the app</div>-->
            <!--                <row>-->
            <!--                    <column xs="1/2" md="full" class="poppins-medium tracking-normal leading-tight">-->
            <!--                        <btn class="md:mb-2 xs:mr-2 md:mr-0 md:w-64 text-secondary" outlined block>-->
            <!--                            <icon icon="apple" class="mr-2 mb-1" size="lg"></icon>-->
            <!--                            Apple store-->
            <!--                        </btn>-->
            <!--                    </column>-->
            <!--                    <column xs="1/2" md="full" class="poppins-medium tracking-normal leading-tight">-->
            <!--                        <btn outlined block class="xs:ml-2 md:ml-0 md:w-64 text-secondary">-->
            <!--                            <icon icon="google-play" class="mr-2" size="1x"></icon>-->
            <!--                            Play store-->
            <!--                        </btn>-->
            <!--                    </column>-->
            <!--                </row>-->
            <!--            </column>-->
        </row>
        <divider class="divider w-screen" color="info"></divider>
        <row class="mb-6" justify="center" style="max-width: 1920px;">
            <div class="text-gray-600 tracking-normal leading-tight mt-6"
            >Copyright {{currentYear}} Psychai Talent Group. All rights reserved
            </div>
        </row>
    </div>
</template>

<script>
    export default {
        name: "Footer",
        components: {
            divider: () => import('@/components/Divider.vue'),
            row: () => import('@/components/display/Row.vue'),
            btn: () => import('@/components/Btn.vue'),
            icon: () => import('@/components/display/Icon.vue'),
            column: () => import('@/components/display/Col.vue'),
        },
        computed: {
            currentYear() {
                return (new Date()).getFullYear();
            }
        },
        methods: {
            getFitt() {
                this.$router.push('/get-fitt');
            }
        }
    }
</script>

<style scoped>
    @media only screen and (max-width: 1639px) {
        .divider {
            left: -1.5rem;
        }
    }

    @media only screen and (min-width: 1640px) {
        .divider {
            left: -10rem;
        }
    }
</style>
